import { Data } from '@blade/std-lib'

export class CoinsLaunchedAll extends Data.TaggedClass('CoinsLaunchedAll') {}

export class CoinsLaunchedHours extends Data.TaggedClass('CoinsLaunchedHours')<{
  hours: 1 | 6 | 12 | 24
}> {}

export class CoinsLaunchedDays extends Data.TaggedClass('CoinsLaunchedDays')<{
  days: 7
}> {}

export type CoinsLaunchedTime =
  | CoinsLaunchedAll
  | CoinsLaunchedHours
  | CoinsLaunchedDays

export const id = (coinsLaunchedTime: CoinsLaunchedTime) =>
  [
    coinsLaunchedTime._tag,
    match.I(coinsLaunchedTime)({
      CoinsLaunchedHours: (x) => x.hours,
      CoinsLaunchedDays: (x) => x.days,
      CoinsLaunchedAll: () => 'all',
    }),
  ].join()

export const match = Data.match

export const units = (
  coinsLaunchedTime: CoinsLaunchedTime,
  options: { onAll: () => number },
) =>
  match.I(coinsLaunchedTime)({
    CoinsLaunchedHours: (x) => x.hours,
    CoinsLaunchedDays: (x) => x.days,
    CoinsLaunchedAll: options.onAll,
  })

export const all = new CoinsLaunchedAll()

export const allTimes = [
  all,
  new CoinsLaunchedDays({ days: 7 }),
  new CoinsLaunchedHours({ hours: 24 }),
  new CoinsLaunchedHours({ hours: 12 }),
  new CoinsLaunchedHours({ hours: 6 }),
  new CoinsLaunchedHours({ hours: 1 }),
] as const
